export const TEAMS_AM = {
    
}